export const MERGE_TAG_SUBSTITUTIONS: Record<string, string> = {
  FIRST_NAME: 'Jane',
  LAST_NAME: 'Doe',
  COMPANY_NAME: 'Acme Care',
  SIGNUP_LINK: 'https://pay.gocardless.com/example',
};

export const substituteMergeTags = (text: string): string =>
  text.replace(/\{\{(\w+)\}\}/g, (_, tag) => MERGE_TAG_SUBSTITUTIONS[tag] ?? `{{${tag}}}`);
